import QuestionResult from "../QuestionResult";
import { useSelector } from "react-redux";
import resultListStyles from "@educaplay/core/GameProvider/GameProviderScore/Results/Results.module.scss";

export default function ResultsScreen(props) {
  const { questions, hideEnunciado, hideAnswers, correctSingleAnswers } = props;

  const showAnswers = useSelector((state) => state.game.showSolutions);

  return (
    <div className={resultListStyles.container}>
      {questions.map((question, index) => (
        <QuestionResult
          key={question.id}
          question={question}
          questionNumber={index + 1}
          showAnswers={showAnswers}
          hideEnunciado={hideEnunciado}
          hideAnswers={hideAnswers}
          correctSingleAnswers={correctSingleAnswers}
        />
      ))}
    </div>
  );
} 
